import React from 'react';

import { Typography, CardMedia, Box } from '@material-ui/core';
import ES from 'components/ExplainString';
import Experience from 'components/Experience';
import ProjectLink from 'components/ProjectLink';


import explains from 'data/explains'

import {Grid} from '@material-ui/core';

export default function gen(props){
  return (<>
    <Experience
      organization='Arm'
      startDate='Apr 2020'
      endDate='Sep 2020'
      title='Six-months Industrial Placement in GIC and GPU Team'
    >

      <ul>
        <li>Understand how to use <ES {...explains['Confluence']}>Confluence</ES>, <ES {...explains['Jira']}>Jira</ES> and <ES {...explains['Gerrit']}>Gerrit</ES> effectively</li>
        <li>Created a configurable test bench to validate consumer facing script</li>
        <li>Created <ES {...explains['SIPOC']}>SIPOC</ES> model for internal tools, helping colleges from different team to navigate</li>
      </ul>
    </Experience>
  </>)
}
